/* eslint-disable eqeqeq */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  CircularProgress,
  TextField,
  InputAdornment,
  Grid,
  Tooltip
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import InfoIcon from "@material-ui/icons/Info";
import { IsEmpty } from "../../../../utils/helper";
// import CkLogo from "../../../../assets/images/ck_logo_new.png";
import AllProductsIcon from "../../../../assets/images/all_product.jpg";

const useStyles = () => ({
  card: {
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 4px 4px 0 rgba(0, 0, 0, 0.2), 0 2px 15px 0 rgba(0, 0, 0, 0.19)",
    borderRadius: 10,
    //height: "100%",
  },
  title: {
    color: "#3f51b5",
    display: "flex",
    fontSize: 14,
    marginTop: 5,
    width: "80%",
    marginLeft: 5,
  },
  titleIcon: {
    marginRight: 20,
    fontSize: 28,
  },
  titleDivider: {
    width: "80%",
    backgroundColor: "#3f51b5",
    opacity: "0.5",
    marginLeft: 20,
    marginBottom: 10,
  },
  cardContent: {
    // width: "95%",
    // overflow: "auto",
    overflowY: "scroll",
  },
  listItem: {
    outline: "none",
    cursor: "pointer",
    padding: 1,
    paddingLeft: 2,
  },
  listItemDisputed: {
    outline: "none",
    cursor: "pointer",
    padding: 1,
    paddingLeft: 2,
    backgroundColor: "#ffe0a8",
    // color: "white",
  },
  statusLabel: {
    fontWeight: 600,
    marginRight: 7,
    fontSize: 14,
    width: "90%",
    overflowWrap: "break-word",
  },
  resize: {
    padding: 10,
  },
  circularProgressStyle: {
    marginTop: 10,
    display: "flex",
    justifyContent: "center",
  },
  primaryTextStyle: {
    fontSize: 15,
    overflowWrap: "break-word",
    width: "63%",
  },
  secondaryTextStyle: {
    fontSize: 12,
    color: "#787676",
  },
  filterBtn: {
    fontSize: 11,
    textTransform: "capitalize",
    marginLeft: 4,
    marginRight: 4,
  },
  filterBtnContainer: {
    display: "flex",
    marginBottom: 5,
    marginRight: 5,
    marginLeft: 5,
    width: "100%",
    // width: "max-content"
  },

  formControl: {
    margin: 15,
    minWidth: 250,
  },
  selectEmpty: {
    //marginTop: theme.spacing(2),
  },
});

class OrderTab extends React.Component {
  //textFieldRef = null;
  constructor(props) {
    super(props);
    this.state = {
      ordersData: [],
    };
  }

  // componentDidMount() {
  //   window.addEventListener("resize", this.handleResize);
  //   // Typical usage (don't forget to compare props):
  //   this.setState({
  //       ordersData:this.props.ordersData
  //     })

  //     console.log("componentDidMount",this.props.ordersData);
  // }
  //   componentDidUpdate(prevProps) {
  //     window.addEventListener("resize", this.handleResize);
  //     // Typical usage (don't forget to compare props):
  //     if (JSON.stringify(this.props.ordersData) !== JSON.stringify(prevProps.ordersData)) {
  //       this.setState({
  //         ordersData:this.props.ordersData
  //       },)
  //       console.log("componentDidUpdate",this.props.ordersData);
  //     }

  //     console.log("b:", this.props.ordersData);
  //     console.log("c:", prevProps.ordersData);
  //     console.log("a:", JSON.stringify(this.props.ordersData) !== JSON.stringify(prevProps.ordersData));
  //   }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    // this.setState({
    //  // cardHeight: window.innerHeight - 10, // Adjust the offset value as needed
    // });
  };

  render() {
    const { classes } = this.props;

    console.log("ORDERS DETAIL ===>> ", this.props);

    const minWidthValue = (21.94 / 100) * window.innerWidth;

    return (
      <React.Fragment>
        <Card
          style={{
            minWidth: minWidthValue,
            maxWidth: minWidthValue,
            minHeight: window.innerHeight - 135,
            maxHeight: window.innerHeight - 135,
          }}
          className={classes.card}
        >
          <CardContent className={classes.cardContent}>
            {this.props.values.ordersDataLoading ? (
              <div className={classes.circularProgressStyle}>
                <CircularProgress />
              </div>
            ) : (
              <>
                <div>
                  <TextField
                    label="Search By Order# /Job#"
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    required
                    fullWidth
                    name="searchBar"
                    value={this.props.values.searchBar}
                    onChange={(e) => this.props.onHandleChange(e)}
                    InputProps={{
                      classes: { input: classes.resize },
                      endAdornment: this.props.values
                        .ordersDataSearchLoading ? (
                        <div
                          style={{
                            opacity: "0.5",
                            marginRight: 5,
                          }}
                        >
                          <CircularProgress color="default" size={25} />{" "}
                        </div>
                      ) : (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <List>
                  {!IsEmpty(this.props.ordersData) &&
                    this.props.ordersData.map((card) => {
                      return (
                        <>
                          {this.props.values.filterStatus == 19 ? (
                            <ListItem
                              key={card.orderId}
                              className={
                                card.isDisputed == 1
                                  ? classes.listItemDisputed
                                  : classes.listItem
                              }
                              onClick={() => this.props.getOrderId(card)}
                              selected={
                                this.props.values.selectedOrder.orderId ===
                                card.orderId
                              }
                              style={{
                                borderBottom:
                                  card.isDisputed == 1
                                    ? "1px solid white"
                                    : "1px solid rgb(241 234 234)",
                              }}
                            >
                              <ListItemAvatar
                                style={{ marginLeft: 10, marginRight: 10 }}
                              >
                                <div
                                  style={{ fontSize: 16, textAlign: "center" }}
                                >
                                  <img
                                    alt="img"
                                    style={{
                                      height: 55,
                                      width: 55,
                                      borderRadius: 8,
                                    }}
                                    src={AllProductsIcon}
                                  />
                                </div>
                              </ListItemAvatar>
                              <ListItemText
                                disableTypography
                                primary={
                                  <Typography
                                    className={classes.primaryTextStyle}
                                  >
                                    {"O# "}
                                    {card.orderId}
                                  </Typography>
                                }
                                secondary={
                                  <>
                                    <Typography
                                      className={classes.secondaryTextStyle}
                                    >
                                      {"Status : "}
                                      {card.statusLabel}{" "}
                                    </Typography>
                                    <Typography
                                      className={classes.secondaryTextStyle}
                                    >
                                      {" "}
                                      {card.createdOn}{" "}
                                    </Typography>
                                  </>
                                }
                              />
                            </ListItem>
                          ) :
                            <>
                              {this.props.values.filterStatus == 0 || this.props.values.filterStatus == 1 || this.props.values.filterStatus == 2 || this.props.values.filterStatus == 13 ?
                                (
                                  <React.Fragment key={card.orderId}>
                                    <ListItem

                                      className={
                                        card.items != null ? (card.items.some(item => item.isDisputed == 1)
                                          ? classes.listItemDisputed
                                          : classes.listItem) :
                                          classes.listItem
                                      }
                                      style={{
                                        border:
                                          card.items != null ?
                                            (card.items.some(item => item.isDisputed == 1)
                                              ? "1px solid white"
                                              : "1px solid rgb(241 234 234)") : "1px solid rgb(241 234 234)"
                                        ,
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        padding: "16px",
                                      }}
                                    >
                                      {/* Order Header Section */}
                                      <div style={{ width: "100%", marginBottom: "12px" }}>
                                        <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
                                          <Typography
                                            style={{
                                              fontWeight: 600,
                                              fontSize: 16,
                                              color: "#333",
                                              marginRight: "8px"
                                            }}
                                          >
                                            Order # {card.orderId}
                                          </Typography>
                                          {/* {this.props.values.filterStatus != 0 && ( */}
                                          <Tooltip
                                            title={
                                              <React.Fragment>
                                                <div style={{ padding: "4px", fontSize: "13px" }}>
                                                  <div style={{ marginBottom: "6px" }}><strong>Name:</strong> {card.createdBy}</div>
                                                  <div style={{ marginBottom: "6px" }}><strong>Number:</strong> {card.mobileNo}</div>
                                                  <div><strong>Address:</strong> {card.address}</div>
                                                </div>
                                              </React.Fragment>
                                            }
                                            placement="right-start"
                                          >
                                            <InfoIcon style={{ fontSize: 18, color: "#3f51b5", cursor: "pointer" }} />
                                          </Tooltip>
                                          {/* )} */}
                                        </div>
                                        <Typography style={{ fontSize: 12, color: "#666" }}>
                                          Status: {card.orderStatusLabel}
                                        </Typography>
                                        <Typography style={{ fontSize: 12, color: "#666" }}>
                                          Received at: {card.createdOn}
                                        </Typography>


                                      </div>



                                      {/* Items Section */}
                                      <div style={{ width: "100%" }}>


                                        {!IsEmpty(card.items) &&
                                          card.items.map((item, index) => (
                                            <div
                                              key={item.jobId}
                                              onClick={() =>
                                                this.props.getOrderId({
                                                  ...card,
                                                  ...item,
                                                  jobId: item.jobId,
                                                })
                                              }
                                              style={{

                                                display: "flex",
                                                alignItems: "center",
                                                padding: "8px",
                                                marginBottom: index < card.items.length - 1 ? "8px" : "0",
                                                backgroundColor:
                                                  this.props.values.selectedOrder.jobId === item.jobId
                                                    ? "#e3f2fd"
                                                    : "transparent",
                                                borderRadius: "4px",
                                                cursor: "pointer",
                                                border:
                                                  this.props.values.selectedOrder.jobId === item.jobId
                                                    ? "1px solid #79bef6ff"
                                                    : "1px solid #878787",
                                              }}
                                            >
                                              {/* Item Image */}
                                              <div style={{ marginRight: "12px" }}>
                                                <img
                                                  alt="img"
                                                  style={{
                                                    height: 50,
                                                    width: 50,
                                                    borderRadius: 6,
                                                  }}
                                                  src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${item.thumbnail}`}
                                                />
                                                <Typography style={{ fontSize: 10, color: "#666", border: "1px solid rgb(231 231 231)", textAlign: "center", borderRadius: "5px" }}>
                                                  {item.statusLabel}
                                                </Typography>
                                              </div>

                                              {/* Item Details */}
                                              <div style={{ flex: 1 }}>
                                                <Typography
                                                  style={{
                                                    fontWeight: 800,
                                                    fontSize: 14,
                                                    color: "#333",
                                                    marginBottom: "2px",

                                                  }}
                                                >
                                                  Job# {item.jobId}
                                                </Typography>
                                                <Typography
                                                  style={{
                                                    fontWeight: 650,
                                                    fontSize: 11,
                                                    color: "#333",

                                                  }}
                                                >
                                                  Item#: {item.productLabel}
                                                </Typography>
                                                {this.props.values.filterStatus != 13 ?
                                                  (
                                                    <>
                                                      <Typography
                                                        style={{

                                                          fontSize: 8,
                                                          color: "#333",

                                                        }}
                                                      >
                                                        <b> Received at: </b> {item.createdOn}
                                                      </Typography>
                                                      <Typography
                                                        style={{

                                                          fontSize: 8,
                                                          color: "#333",

                                                        }}
                                                      >
                                                        <b>  Changed on: </b> {item.jobStatusChangedOn}
                                                      </Typography>
                                                    </>
                                                  ) :
                                                  (
                                                    <Typography
                                                      style={{

                                                        fontSize: 8,
                                                        color: "#333",

                                                      }}
                                                    >
                                                      <b>  Assigned Tray: </b> {item.trayCode}
                                                    </Typography>
                                                  )
                                                }




                                                {item.isDisputed == 1 && (
                                                  <Typography
                                                    style={{
                                                      fontSize: 11,
                                                      color: "#d32f2f",
                                                      fontWeight: 500,
                                                      marginTop: "2px",
                                                    }}
                                                  >
                                                    ⚠️ Disputed
                                                  </Typography>
                                                )}
                                              </div>
                                            </div>
                                          ))}
                                      </div>
                                    </ListItem>
                                  </React.Fragment>
                                )
                                :

                                (
                                  <ListItem
                                    key={card.jobId}
                                    className={
                                      card.isDisputed == 1
                                        ? classes.listItemDisputed
                                        : classes.listItem
                                    }
                                    onClick={() => this.props.getOrderId(card)}
                                    selected={
                                      this.props.values.selectedOrder.jobId ===
                                      card.jobId
                                    }
                                    style={{
                                      borderBottom:
                                        card.isDisputed == 1
                                          ? "1px solid white"
                                          : "1px solid rgb(241 234 234)",
                                    }}
                                  >
                                    <ListItemAvatar
                                      style={{ marginLeft: 10, marginRight: 10 }}
                                    >
                                      <div
                                        style={{ fontSize: 16, textAlign: "center" }}
                                      >
                                        <img
                                          alt="img"
                                          style={{
                                            height: 55,
                                            width: 55,
                                            borderRadius: 8,
                                          }}
                                          src={`${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/albums/C01ImageView?fileName=${card.thumbnail}`}
                                        />
                                      </div>
                                    </ListItemAvatar>
                                    <ListItemText
                                      disableTypography
                                      primary={
                                        <Typography
                                          className={classes.primaryTextStyle}
                                        >
                                          {"O# "}
                                          {card.orderId + " - J# " + card.jobId}{" "}
                                        </Typography>
                                      }
                                      secondary={
                                        <>
                                          <Typography
                                            className={classes.secondaryTextStyle}
                                          >
                                            {"Status : "}
                                            {card.statusLabel}{" "}
                                          </Typography>
                                          <Typography
                                            className={classes.secondaryTextStyle}
                                          >
                                            {" "}
                                            {card.createdOn}{" "}
                                          </Typography>
                                        </>
                                      }
                                    />
                                  </ListItem>
                                )
                              }
                            </>
                          }
                        </>
                      );
                    })}
                </List>
              </>
            )}
          </CardContent>
        </Card>
      </React.Fragment>
    );
  }
}

OrderTab.propTypes = {
  classes: PropTypes.object.isRequired,
  values: PropTypes.object,
  ordersData: PropTypes.array,
  getOrderId: PropTypes.func,
  onHandleChange: PropTypes.func,
};

OrderTab.defaultProps = {
  values: {},
  ordersData: [],
  getOrderId: (fn) => fn,
  onHandleChange: (fn) => fn,
};

export default withStyles(useStyles)(OrderTab);
